module.exports = __webpack_public_path__ + "img/Icon-Chat.462049db.svg";